var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import TextNode from 'ReactComponents/TextNode';
import i18nService from 'ReactServices/i18n.service';
var I18n = function (_a) {
    var code = _a.code, includeMarkup = _a.includeMarkup, params = _a.params, props = __rest(_a, ["code", "includeMarkup", "params"]);
    var text = i18nService.get(code, params) || props.text || '';
    if (includeMarkup) {
        return (React.createElement(TextNode, __assign({}, props),
            React.createElement("span", { "data-testid": "i18n", "data-code": code, dangerouslySetInnerHTML: { __html: text } })));
    }
    return (React.createElement(TextNode, __assign({}, props, { testId: "i18n", "data-code": code }), text));
};
export default I18n;
